// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Assets/Images/contactus1.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Home_services__tytxx {
  margin-bottom: 30px;
}
@media (max-width: 900px) {
  .Home_services__tytxx {
    margin-bottom: 10px;
  }
}
.Home_services__tytxx .Home_button__t15UY {
  text-align: center;
}
.Home_services__tytxx .Home_button__t15UY h3 {
  font-size: 40px;
  text-align: center;
  font-family: "hemi_head";
  color: #FFFFFF;
  border: 1px solid #000000;
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px 4px 4px rgba(0, 0, 0, 0.25);
}
@media (max-width: 900px) {
  .Home_services__tytxx .Home_button__t15UY h3 {
    font-size: 30px;
  }
}
@media (max-width: 500px) {
  .Home_services__tytxx .Home_button__t15UY h3 {
    font-size: 25px;
  }
}
.Home_services__tytxx .Home_button__t15UY button {
  border: none;
  background: #FFFFFF;
  border-radius: 5px;
  width: 150px;
  height: 48px;
  font-family: "hemi_head";
  margin-bottom: 30px;
}

.Home_title__SSS8S {
  text-align: center;
}
.Home_title__SSS8S h2 {
  font-family: "hemi_head";
  font-style: italic;
  font-weight: 400;
  font-size: 40px;
  text-align: center;
  letter-spacing: 0.01em;
  color: #FFFFFF;
  position: relative;
  display: inline-block;
  margin-bottom: 50px;
}
.Home_title__SSS8S h2:before {
  content: "";
  width: 80%;
  height: 1px;
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #ED1C24;
}
.Home_title__SSS8S p {
  color: #ffffff;
  font-weight: 400;
  font-size: 16px;
  max-width: 700px;
  margin: 0px auto 40px auto;
}

.Home_contact__ezesn {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
  background-size: cover;
  padding: 30px 0;
}
.Home_contact__ezesn .Home_text__tpVva {
  text-align: center;
}
.Home_contact__ezesn .Home_text__tpVva h4 {
  font-weight: 400;
  font-size: 36px;
  color: #FFFFFF;
  margin: 0;
  text-shadow: 3px 4px 4px rgba(255, 255, 255, 0.25);
  font-family: "hemi_head";
}
.Home_contact__ezesn .Home_text__tpVva h3 {
  font-weight: 400;
  font-size: 24px;
  color: #ffffff;
  font-family: "hemi_head";
}
.Home_contact__ezesn .Home_text__tpVva h3 span {
  color: #ED1C24;
}
.Home_contact__ezesn .Home_text__tpVva p {
  font-size: 20px;
  color: #ffffff;
  max-width: 450px;
  margin: auto;
}
@media (max-width: 500px) {
  .Home_contact__ezesn .Home_text__tpVva p {
    width: 96%;
  }
}

.Home_aboutUs__PulGF .Home_text__tpVva {
  text-align: center;
}
.Home_aboutUs__PulGF .Home_text__tpVva h3, .Home_aboutUs__PulGF .Home_text__tpVva h1 {
  font-family: "hemi_head";
  font-style: italic;
  font-weight: 400;
  font-size: 40px;
  text-align: center;
  letter-spacing: 0.01em;
  color: #FFFFFF;
  position: relative;
  display: inline-block;
  margin: 30px 0;
}
.Home_aboutUs__PulGF .Home_text__tpVva h3:before, .Home_aboutUs__PulGF .Home_text__tpVva h1:before {
  content: "";
  width: 80%;
  height: 1px;
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  background-color: #ED1C24;
}
.Home_aboutUs__PulGF .Home_text__tpVva p {
  font-size: 20px;
  color: #ffffff;
  max-width: 800px;
  margin: auto;
  margin-bottom: 40px;
}
@media (max-width: 500px) {
  .Home_aboutUs__PulGF .Home_text__tpVva p {
    width: 96%;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Home/Home.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;AAAE;EAFF;IAGI,mBAAA;EAGF;AACF;AAFE;EACE,kBAAA;AAIJ;AAHI;EACE,eAAA;EACA,kBAAA;EACA,wBAAA;EACA,cAAA;EACA,yBAAA;EACA,6EAAA;AAKN;AAJM;EAPF;IAQI,eAAA;EAON;AACF;AANM;EAVF;IAWI,eAAA;EASN;AACF;AAPI;EACE,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,wBAAA;EACA,mBAAA;AASN;;AALA;EACE,kBAAA;AAQF;AANE;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;AAQJ;AANI;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;EACA,yBAAA;AAQN;AALE;EACE,cAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;AAOJ;;AAJA;EACE,oEAAA;EACA,sBAAA;EACA,eAAA;AAOF;AALE;EACE,kBAAA;AAOJ;AALI;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,SAAA;EACA,kDAAA;EACA,wBAAA;AAON;AAJI;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,wBAAA;AAMN;AAJM;EACE,cAAA;AAMR;AAFI;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;AAIN;AAHM;EALF;IAMI,UAAA;EAMN;AACF;;AACE;EACE,kBAAA;AAEJ;AADI;EACE,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;AAGN;AADM;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;EACA,yBAAA;AAGR;AACI;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;AACN;AAAM;EANF;IAOG,UAAA;EAGL;AACF","sourcesContent":[".services{\n  margin-bottom: 30px;\n  @media (max-width: 900px) {\n    margin-bottom: 10px;\n  }\n  .button{\n    text-align: center;\n    h3{\n      font-size: 40px;\n      text-align: center;\n      font-family: \"hemi_head\";\n      color: #FFFFFF;\n      border: 1px solid #000000;\n      text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25), 0px 4px 4px rgba(0, 0, 0, 0.25);\n      @media (max-width: 900px) {\n        font-size: 30px;\n      }\n      @media (max-width: 500px) {\n        font-size: 25px;\n      }\n    }\n    button{\n      border: none;\n      background: #FFFFFF;\n      border-radius: 5px;\n      width: 150px;\n      height: 48px;\n      font-family: \"hemi_head\";\n      margin-bottom: 30px;\n    }\n  }\n}\n.title {\n  text-align: center;\n\n  h2 {\n    font-family: \"hemi_head\";\n    font-style: italic;\n    font-weight: 400;\n    font-size: 40px;\n    text-align: center;\n    letter-spacing: 0.01em;\n    color: #FFFFFF;\n    position: relative;\n    display: inline-block;\n    margin-bottom: 50px;\n\n    &:before {\n      content: \"\";\n      width: 80%;\n      height: 1px;\n      position: absolute;\n      bottom: -10px;\n      left: 50%;\n      transform: translateX(-50%);\n      background-color: #ED1C24;\n    }\n  }\n  p{\n    color: #ffffff;\n    font-weight: 400;\n    font-size: 16px;\n    max-width: 700px;\n    margin: 0px auto 40px auto;\n  }\n}\n.contact{\n  background: url(\"../../Assets/Images/contactus1.png\") no-repeat center;\n  background-size: cover;\n  padding: 30px 0;\n\n  .text {\n    text-align: center;\n\n    h4 {\n      font-weight: 400;\n      font-size: 36px;\n      color: #FFFFFF;\n      margin: 0;\n      text-shadow: 3px 4px 4px rgba(255, 255, 255, 0.25);\n      font-family: \"hemi_head\";\n    }\n\n    h3 {\n      font-weight: 400;\n      font-size: 24px;\n      color: #ffffff;\n      font-family: \"hemi_head\";\n\n      span {\n        color: #ED1C24;\n      }\n    }\n\n    p {\n      font-size: 20px;\n      color: #ffffff;\n      max-width: 450px;\n      margin: auto;\n      @media (max-width: 500px) {\n        width: 96%;\n      }\n    }\n  }\n}\n.aboutUs{\n  //background: url(\"../../Assets/Images/contactus2.png\") no-repeat center;\n  //background-size: cover;\n  .text {\n    text-align: center;\n    h3, h1 {\n      font-family: \"hemi_head\";\n      font-style: italic;\n      font-weight: 400;\n      font-size: 40px;\n      text-align: center;\n      letter-spacing: 0.01em;\n      color: #FFFFFF;\n      position: relative;\n      display: inline-block;\n      margin: 30px 0;\n\n      &:before {\n        content: \"\";\n        width: 80%;\n        height: 1px;\n        position: absolute;\n        bottom: -10px;\n        left: 50%;\n        transform: translateX(-50%);\n        background-color: #ED1C24;\n      }\n    }\n\n    p {\n      font-size: 20px;\n      color: #ffffff;\n      max-width: 800px;\n      margin: auto;\n      margin-bottom: 40px;\n      @media (max-width: 500px) {\n       width: 96%;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"services": `Home_services__tytxx`,
	"button": `Home_button__t15UY`,
	"title": `Home_title__SSS8S`,
	"contact": `Home_contact__ezesn`,
	"text": `Home_text__tpVva`,
	"aboutUs": `Home_aboutUs__PulGF`
};
export default ___CSS_LOADER_EXPORT___;
